import React from "react";
import "./icon-svg.css";
import { AppIcon } from "./app-icon.model";

type IconSvgProps = {
  path: AppIcon;
  className?: string;
  onClick?: () => void;
};

const IconSvg: React.FC<IconSvgProps> = ({ path, className = "", onClick }) => {
  const maskImagePath = `url("/assets/media/icons/${path}.svg")`;

  return (
    <div
      className={`iconSvg ${className}`}
      onClick={onClick}
      style={{
        WebkitMaskImage: maskImagePath,
        maskImage: maskImagePath,
      }}
    />
  );
};

export default IconSvg;
